import React, {useCallback, useMemo} from 'react';
import {useDispatch} from 'react-redux';

import {getPaginatedRowNumber} from 'src/components/main-column';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Icons} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {Cell, Row} from '@pb/kit-component-table';


import {next} from '../../entitlement-drawer.slice';
import {EntitlementType as EntitlementTypes} from '../../typedef';

import type {EntitlementResource} from 'src/openapi/admin/models/EntitlementResource';
import type {Pagination} from 'src/openapi/admin/models/Pagination';

type Props = {
    resource: EntitlementResource,
    pagination: Pagination,
    index: number,
    setResourceForDeletion: (resource: EntitlementResource) => void,
};

export const NotAssociatedResourceRow = ({resource, pagination, index, setResourceForDeletion}: Props) => {
    const dispatch = useDispatch();

    const openResource = useCallback(() => {
        dispatch(next({entitlementType: EntitlementTypes.RESOURCE, entitlementId: resource.id}));
    }, [dispatch, resource]);

    const removeResource = useCallback(() => {
        setResourceForDeletion(resource);
    }, [setResourceForDeletion, resource]);

    const rowNumber = useMemo(() => (
        getPaginatedRowNumber({...pagination, index: index + 1})
    ), [pagination, index]);

    return (
        <Row>
            <Cell>{rowNumber}</Cell>
            <Cell>
                <a onClick={openResource}>
                    <EllipsisTextHint title={resource.name}>
                        {resource.name}
                    </EllipsisTextHint>
                </a>
            </Cell>
            <Cell>
                <BasicIconButton onClick={removeResource} iconProps={{type: Icons.TRASH}}/>
            </Cell>
        </Row>
    );
};
